"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetch = require("isomorphic-fetch");
var CalendarApi = (function () {
    function CalendarApi() {
    }
    CalendarApi.getEventsForDates = function (culture, startDate, endDate) {
        var requestString = '/';
        if (culture.length > 0)
            requestString += culture + '/';
        requestString = requestString + this.aceCalendarAPIRoute + "?startDate=" + startDate + "&endDate=" + endDate;
        return fetch(requestString, {
            credentials: 'include'
        })
            .then(function (response) { return response.json(); });
    };
    CalendarApi.getProductionEventsForDates = function (culture, productionSeasonId, startDate, endDate) {
        var requestString = '/';
        if (culture.length > 0)
            requestString += culture + '/';
        requestString = requestString + this.aceCalendarAPIRoute + "/" + productionSeasonId.toString() + "/" + "?startDate=" + startDate + "&endDate=" + endDate;
        return fetch(requestString, {
            credentials: 'include'
        })
            .then(function (response) { return response.json(); });
    };
    CalendarApi.aceCalendarAPIRoute = "ace-api/events";
    return CalendarApi;
}());
exports.default = CalendarApi;
//# sourceMappingURL=calendar-api.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@adage/ace-calendar/app/apis/calendar-api.js
// module id = 140
// module chunks = 0